import { useSyncExternalStore } from 'react';

export const MD_QUERY = '(min-width: 768px)';
export const LG_QUERY = '(min-width: 1024px)';
// Matches the project's custom `--breakpoint-xl` (72rem) in src/styles/main.css,
// not Tailwind's default 1280px `xl`.
export const XL_QUERY = '(min-width: 72rem)';

export function useMediaQuery(query: string): boolean {
	return useSyncExternalStore(
		(cb) => {
			const mql = window.matchMedia(query);
			mql.addEventListener('change', cb);
			return () => mql.removeEventListener('change', cb);
		},
		() => window.matchMedia(query).matches,
		() => false
	);
}
